import {endpoints} from './endpoints'
import request from '../../request'

export function create(data, onUploadProgress = null) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.create,
			method: 'post',
			data,
			onUploadProgress
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function update(data, onUploadProgress = null) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.update,
			method: 'post',
			data,
			onUploadProgress
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function list(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.list,
			method: 'get',
			params: data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function listPaymentStatus(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.listPaymentStatus,
			method: 'get',
			params: data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getAdditionalByID(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getAdditionalByID,
			method: 'get',
			params: data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function addRevision(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addRevision,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createAdditionalLikely(data, onUploadProgress = null) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createAdditionalLikely,
			method: 'post',
			data,
			onUploadProgress
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function listAdditionalLikely(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.listAdditionalLikely,
			method: 'get',
			params: data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getAdditionalLikely(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getAdditionalLikely,
			method: 'get',
			params: data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function changeAdditionalStatus(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.changeAdditionalStatus,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getLastAdditionalData(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getLastAdditionalData,
			method: 'get',
			params: data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function newPaymentStatus(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.newPaymentStatus,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function editPaymentStatus(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.editPaymentStatus,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function setStatusToAgps(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setStatusToAgps,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function addGlobalPaymentStatusParticipant(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addGlobalPaymentStatusParticipant,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function removeGlobalPaymentStatusParticipant(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.removeGlobalPaymentStatusParticipant,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updatePaymentStatus(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updatePaymentStatus,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function setStatusToPaymentStatus(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setStatusToPaymentStatus,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function newPaymentStatusInteraction(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.newPaymentStatusInteraction,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function changeVisualizationStatus(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.changeVisualizationStatus,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getAdditionalPDF(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getAdditionalPDF,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function sendAdditionalMail(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.sendAdditionalMail,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function addAdditionalAssociations(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addAdditionalAssociations,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function removeAdditionalAssociations(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.removeAdditionalAssociations,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function addObservation(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addObservation,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function addInteraction(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addInteraction,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getZippedFiles(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getZippedFiles,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createAdditionalProgress(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createAdditionalProgress,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getTareaAgpAssociation(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getTareaAgpAssociation,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getAdditionalsSimpleSummary(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getAdditionalsSimpleSummary,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function exportAdditionalStatusByProject(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.exportAdditionalStatusByProject,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function exportAdditionalPaymentStatusByProject(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.exportAdditionalPaymentStatusByProject,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function exportCombinedAdditionalData(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.exportCombinedAdditionalData,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getAgpsPDF(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getAgpsPDF,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}